// Next Diamonds — Cart sale countdown banner
// Updates [data-cart-sale-timer] every second with HH:MM:SS until
// the [data-end-time] timestamp. Switches to "Days · HH:MM" beyond 24h.
// Hides the banner on expiry.

(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function format(diffMs) {
    if (diffMs <= 0) return null;
    var total = Math.floor(diffMs / 1000);
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return pad(d) + 'D ' + pad(h) + 'H ' + pad(m) + 'M ' + pad(s) + 'S';
  }

  function tick(banner) {
    var endIso = banner.getAttribute('data-end-time');
    if (!endIso) return;
    var end = new Date(endIso).getTime();
    if (isNaN(end)) return;
    var diff = end - Date.now();
    var text = format(diff);
    var timerEl = banner.querySelector('[data-cart-sale-timer]');
    if (!timerEl) return;
    if (text === null) {
      banner.style.display = 'none';
      return;
    }
    timerEl.textContent = text;
  }

  function init() {
    var banners = document.querySelectorAll('[data-cart-sale-banner]');
    if (!banners.length) return;
    banners.forEach(function (b) {
      if (b.__ndSaleBannerInit) return;
      b.__ndSaleBannerInit = true;
      tick(b);
      setInterval(function () { tick(b); }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:updated', init);
})();
